import { ReactNode, useState } from "react";

export const TABS = {
  notification: "notification",
  task: "task",
};

export function TabController({
  children,
}: {
  children: (props: {
    tab: string;
    setTab: (tab: string) => void;
  }) => ReactNode;
}) {
  const [tab, setTab] = useState(TABS.notification);

  return children({ tab, setTab });
}
